/**
 * ServiceTitan sidebar configuration
 */
export default {
  pathPrefix: 'service_titan',
  items: [
    {
      label: 'Tenants',
      href: '/service_titan/tenants',
      icon: 'fa-solid fa-server',
      activePath: 'service_titan/tenants'
    },
    {
      label: 'Linking',
      href: '/service_titan/linking',
      icon: 'fa-solid fa-link',
      activePath: 'service_titan/linking'
    }
  ]
}
